import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

let resources = {}
const namespaces = ['general', 'about', 'app', 'help']
const supportedLngs = ['en', 'zh-TW', 'zh-CN']

namespaces.forEach(name => {
  supportedLngs.forEach(lang => {
    const data = require(`./locales/${lang}/${name}.json`)

    resources = {
      ...resources,
      [lang]: {
        ...resources[lang],
        [name]: data,
      },
    }
  })
})

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react
    },
    // react i18next special options
    react: {
      useSuspense: false,
    },
  })

export default i18n
